/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * getOnRampConfigCommand.js --
 *
 *
 */

import { globalArray } from "../jscdkClient";
import GetOnRampConfigHandler from "../controllers/getOnRampConfigHandler";

export default function GetOnRampConfigCommand() {}

/**
 * Invoked by JSCDKController
 *
 */

GetOnRampConfigCommand.prototype.execute = function () {
   let getOnRampConfigObject = globalArray["get-on-ramp-config"];

   getOnRampConfigObject = new GetOnRampConfigHandler();
   globalArray[getOnRampConfigObject.messageName] = getOnRampConfigObject;
   globalArray[getOnRampConfigObject.responseTag] = getOnRampConfigObject;

   if (globalArray["router"]) {
      getOnRampConfigObject.setRequestXML();
      const handlerList = getOnRampConfigObject.composeHandlerList();
      globalArray["router"].postMessage(handlerList);
   }
};
